import LTR from "@brand-icons/ploom/chevron-forward/chevron-forward-ltr.svg";
import RTL from "@brand-icons/ploom/chevron-forward/chevron-forward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ChevronForwardIcon = iconFactory("ChevronForwardIcon", LTR, RTL);
